import { memo } from 'react';
import { LoadingIcon } from '../../../misc/icons/Icons';

const SubmitButton = ({
	title = '', loading = false, handleClick, disabled = false, type = 'button',
}) => (
	<span className="relative block w-full rounded-md shadow-sm">
		{loading && <LoadingSpinner />}
		<button
			disabled={disabled || loading}
			// eslint-disable-next-line react/button-has-type
			type={type}
			onClick={handleClick}
			className="text-left flex justify-center w-full items-center px-4 py-2.5 font-semibold text-[1.0625rem] leading-7 text-white group bg-oly-blue-default can-hover:hover:bg-oly-blue-default-dark focus-visible:bg-oly-blue-default-dark focus:outline-none disabled:opacity-75"
			aria-labelledby={title}
		>
			{title}
		</button>
	</span>
);

const LoadingSpinner = () => (
	<div className="absolute inset-0 z-10 flex items-center justify-center cursor-not-allowed">
		<LoadingIcon className="w-6 h-6 text-white animate-spin" />
	</div>
);

export default memo(SubmitButton);
